import { getStore } from "../store/store";
import { mutatorAction } from "satcheljs";
import { isGlobalFeatureEnabled } from "owa-feature-flags";

const resetMessageAdListSelectionMutator: () => void = mutatorAction("resetMessageAdListSelection", function (): void {
    const store = getStore();
    if (store) {
        store.selectedAdId = "";
        if (isGlobalFeatureEnabled("adsexp-nativeTwoClick")) {
            store.nativeAdTwoClickView = undefined;
        }
    }
});
export default resetMessageAdListSelectionMutator;
